import React from "react";
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as RobotSvg } from '../../images/robot.svg';

const RobotIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} component={RobotSvg} viewBox="0 0 24 24" ref={ref} />
));

export default RobotIcon